var $fea24d77fd1447b9$exports = {};
document.querySelectorAll('.sidebar li a').forEach((element)=>{
    element.classList.remove('bg-active', 'text-active-text');
});
document.querySelectorAll('.sidebar li:nth-child(5) a').forEach((element)=>{
    element.classList.add('bg-active', 'text-active-text');
});


//# sourceMappingURL=imsa-endurance-series-2026-season-3.487517d8.js.map
